//　「gpo-hide-oos-swatches.js」　地口が新規作成（2026/1/27）
//　GloboのPREMIUMプランでは在庫管理がShopifyと連動していないため、在庫切れオプションが非表示にならないのを改善するソース

(() => {
  console.log('[gpo-oos] loaded');

  const ITEM_SELECTOR = '.gpo-swatches.gpo-ov-item';
  const INPUT_SELECTOR = 'input[gpo-data-product-handle][gpo-data-variant-id]';

  const productCache = new Map(); // handle -> product json promise

  async function fetchProduct(handle) {
    const url = `/products/${encodeURIComponent(handle)}.js`;
    const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error(`fetch failed: ${url} (${res.status})`);
    return res.json();
  }

  async function isVariantAvailable(handle, variantId) {
    if (!productCache.has(handle)) productCache.set(handle, fetchProduct(handle));
    const product = await productCache.get(handle);
    const v = (product.variants || []).find(x => String(x.id) === String(variantId));
    return v ? !!v.available : true; // 見つからない場合は表示維持（安全側）
  }

  function getGroupInputsByName(name) {
    return Array.from(document.querySelectorAll(`input[name="${CSS.escape(name)}"][gpo-data-product-handle][gpo-data-variant-id]`));
  }

  function pickFirstVisible(inputs) {
    return inputs.find(i => {
      const item = i.closest(ITEM_SELECTOR);
      return item && item.style.display !== 'none';
    });
  }

  // すでに処理済みかどうか（同じ要素を何回も判定しない）
  const done = new WeakSet();

  async function applyOnce(input) {
    if (done.has(input)) return;
    done.add(input);

    const handle = input.getAttribute('gpo-data-product-handle');
    const variantId = input.getAttribute('gpo-data-variant-id');
    if (!handle || !variantId) return;

    let available = true;
    try {
      available = await isVariantAvailable(handle, variantId);
    } catch (e) {
      // 取得失敗＝ハンドル不一致が多いので、デバッグ用に出しておく
      console.warn('[gpo-oos] product fetch error', handle, e);
      return;
    }

    if (!available) {
      const item = input.closest(ITEM_SELECTOR);
      if (!item) return;

      const wasChecked = input.checked;
      item.style.display = 'none';

      // 選択中だった場合は、同グループから表示中のものに切替
      if (wasChecked && input.name) {
        const group = getGroupInputsByName(input.name);
        const next = pickFirstVisible(group);
        if (next) {
          next.checked = true;
          next.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  async function scanAndApply() {
    const inputs = document.querySelectorAll(INPUT_SELECTOR);
    for (const input of inputs) {
      applyOnce(input);
    }
  }

  function boot() {
    scanAndApply();

    // GloboがDOMを差し替えても追従する
    const mo = new MutationObserver(() => scanAndApply());
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
